// Centralized data for the Ezhil Biomedical website

export const COMPANY = {
    name: "Ezhil Biomedical",
    fullName: "Ezhil Biomedical Sales and Services",
    tagline: "Trusted Medical Equipment Solutions for Modern Healthcare",
    phone: "+91 90431 87520",
    phoneDigits: "919043187520",
    email: "ezhilbiomedical@gmail.com",
    address: "No.30, Bharathi Nagar, 8th Cross Street, Karuvadikuppam, Puducherry – 605008",
    addressShort: "Puducherry, India",
    rating: "5.0",
    whatsappMsg: "Hello! I'd like to enquire about your medical equipment.",
};

export const NAV_LINKS = [
    { label: "Home", id: "home" },
    { label: "About", id: "about" },
    { label: "Services", id: "services" },
    { label: "Products", id: "products" },
    { label: "Industries", id: "industries" },
    { label: "Gallery", id: "gallery" },
    { label: "Contact", id: "contact" },
];

export const SERVICES = [
    { icon: "FaStethoscope", title: "Medical Equipment Sales", desc: "Genuine, certified medical equipment from leading global brands." },
    { icon: "FaTools", title: "Biomedical Equipment Service", desc: "Comprehensive servicing for all major hospital equipment." },
    { icon: "FaCogs", title: "Installation Support", desc: "Professional on-site installation by certified engineers." },
    { icon: "FaShieldAlt", title: "Preventive Maintenance", desc: "Scheduled inspections to keep equipment running optimally." },
    { icon: "FaBalanceScale", title: "Calibration Services", desc: "Accurate, traceable calibration as per NABH guidelines." },
    { icon: "FaFileContract", title: "Annual Maintenance Contracts", desc: "AMC plans tailored to hospitals, clinics and labs." },
    { icon: "FaWrench", title: "Equipment Repair", desc: "Quick, reliable repairs with genuine OEM spare parts." },
    { icon: "FaHeadset", title: "Technical Consultation", desc: "Expert advisory for equipment selection & upgrades." },
];

const cat = (name, img) => ({ name, img });

export const PRODUCT_CATEGORIES = [
cat(
  "Medical Equipments",
  "https://as2.ftcdn.net/v2/jpg/02/72/22/01/1000_F_272220138_vj2NbNbpuZoIktW6Q6YTyWXWTI3GERf0.jpg"
),    cat("Hospital Furniture and Beds",          "https://t4.ftcdn.net/jpg/21/04/33/09/240_F_2104330909_7UUxz9MX1VtKh8TWKC4f60gMYi2MzPK3.jpg"),
cat("Medical Gas System ", "https://t3.ftcdn.net/jpg/08/01/28/96/240_F_801289640_o8FMqwdUZNda1eAtZXGkB0JODKHHp5Gf.jpg"),
    cat("Hospital Curtains track and screens",                  "https://t3.ftcdn.net/jpg/21/02/08/98/240_F_2102089845_rV1Viz9YSWjdElmWftEvUK5ew3UpZ7it.jpg"),
    cat("Modular Operation Theatres",                "https://media.istockphoto.com/id/2160702256/photo/modern-operation-hospital-room-empty-healthcare-surgery-ward.jpg?s=612x612&w=0&k=20&c=9W_Fwdjl2Dh1_d3rago71Z2VNp9xMuFGztHxDaYJRh8="),
    cat("Oxygen Concentrators, Bipap and Cpap",                   "https://myhealthmart.in/wp-content/uploads/2025/11/difference-between-cpap-and-bipap-machine.webp"),
    cat("Autoclaves and Sterilizers equipment",                "https://t4.ftcdn.net/jpg/19/77/25/95/240_F_1977259533_Gd3tz7jg4RYBwlEOh84jegV1s4DlzgKN.jpg"),
    cat("All Laboratory Equipment",                 "https://t3.ftcdn.net/jpg/09/27/29/76/240_F_927297694_Q9MipTmw3jfADsq7dRB1hItIQEhaowrJ.jpg"),
    cat("All Ot and Icu Equipments",          "https://images.unsplash.com/photo-1580420768674-7078c2bebec6?w=800&auto=format&fit=crop"),
    cat("Patient Stretcher and trolleys",                    "https://media.gettyimages.com/id/173472003/photo/doctors-pushing-patient-on-gurney-down-hospital-corridor.jpg?s=612x612&w=0&k=20&c=lZ8VoYy3ZVkkN6mj1LUL65LuGR3grDDUM-cSiP6Rr-c="),
    cat("Hospital Beds",                 "https://media.istockphoto.com/id/1295301481/photo/modern-empty-temporary-intensive-care-emergency-room-is-ready-to-receive-patients-with.jpg?s=612x612&w=0&k=20&c=JS084TTZ4l5cmquQhncNlkUaiohHt762HnopGkpYwgA="),
    cat("All Instruments trolleys",                      "https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcRxajm1cTzEINpqfnyiHs6jMu4qDbG_QyPt4OEELK4SN4hypbcO"),
    cat("Crash Carts and Medicine Trolleys",            "https://d91ztqmtx7u1k.cloudfront.net/ClientContent/Images/ExtraLarge/stainless-steel-crash-cart-trolley-ss-30420230725115501.png"),
    cat("Medical Air and vacuum Compressors",                   "https://praunmetal.com/wp-content/uploads/2025/05/VACUUM-AIR-COMPRESSOR-VARIANTS.jpeg"),
    cat("O2 Regulators, flowmeter and vacuum regulators ",            "https://www.silbermnn.com/wp-content/uploads/2026/07/Oxygen-Suction-Therapy.jpg"),
    cat("All Types of Suction Machines",              "https://image.made-in-china.com/2f0j00cUBqvrHgbypk/40L-M-2-5lx2-High-Negative-Pressure-Diaphragm-Type-Medical-Suction-Pump-Device.webp"),
    cat("All Consumable Products",                    "https://images.unsplash.com/photo-1581595220892-b0739db3ba8c?w=800&auto=format&fit=crop"),
    cat("medical graded copper pipes",                   "https://cpimg.tistatic.com/08318948/b/4/Hard-Brass-Medical-Gas-Pipe-Line-System.jpg"),
    cat("All types of medical gas outlets",          "https://5irorwxhknmkjik.leadongcdn.com/cloud/jmBplKnmRijSljkkonlji/Hfce0728c386c4b8893ee619c3ea28517t.jpg"),
    cat("Hospital wall guard and corner guards",          "https://cpimg.tistatic.com/6160160/b/4/hospital-corner-guard.jpg"),
    cat("Patient warming devices",   "https://d2t0svjwo1hj60.cloudfront.net/media/public/iob-forced-air-warming-system-patient-warmer-04_05_2026-848b95f6.webp"),
    cat("surgicals instruments",           "https://www.diginerve.com/blogs/wp-content/uploads/2024/07/A-Comprehensive-Guide-to-Surgical-Instruments-and-Their-Uses.webp"),
    cat("xray equipments ",  "https://www.perlove.net/wp-content/uploads/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250620095642.png"),
    cat("Biomedical Spare Parts",        "https://5.imimg.com/data5/ON/YL/MY-8865319/biomedical-accessories-500x500.jpg"),
        cat("Biomedical equipment display units",        "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=800&auto=format&fit=crop"),
                cat("Biomedical equipment Electronic boards",        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqm8ugqsDCDKDimcpbApWvG34O7yFS-MY8hQ&s"),


];

export const FEATURED_PRODUCTS = [
    {
        name: "Multi-Parameter Patient Monitor",
        img: "https://i0.wp.com/bamcmedicalltd.com/wp-content/uploads/2022/06/multi-parameter-patient-monitor-cardico-VI-bamc-medical-ltd-panipat.jpg?fit=500%2C500&ssl=1",
        features: ["12.1\" Touch Display", "ECG, SpO2, NIBP, Temp", "Wireless Connectivity", "Battery Backup"]
    },
    {
        name: "ICU Ventilator",
        img: "https://globalsurgicals.in/cdn/shop/files/niscomed-icu-ventilator-6671093.png?v=1779433687",
        features: ["Adult / Paediatric / Neonatal", "Multiple Ventilation Modes", "Hot-swappable Battery", "NIV Support"]
    },
    {
        name: "Defibrillator with Monitor",
        img: "https://5.imimg.com/data5/WO/EO/MY-2778294/defibrillator-monitor-500x500.jpg",
        features: ["Biphasic Technology", "AED + Manual Mode", "SpO2 + ECG Integrated", "Lightweight Design"]
    },
    {
        name: "Oxygen Concentrator 10L",
        img: "https://longfiantech.com/upload/2753/o/23_5_oxygen_concentrator_0.jpg",
        features: ["10 LPM Continuous Flow", "93% ± 3% Purity", "Low Noise Operation", "24x7 Reliable"]
    },
    {
        name: "Anesthesia Workstation",
        img: "https://medansh.in/cdn/shop/files/Anesthesia_Machine_Prestage_Ultra__medansh.webp?v=1744092699",
        features: ["Advanced Ventilation", "Integrated Monitor", "Auto Gas Control", "OT Ready"]
    },
    {
        name: "Digital ECG Machine",
        img: "https://unisonbiomed.com/wp-content/uploads/2023/11/Digital-Three-Channel-ECG-Machine-ECG-1203B.jpg",
        features: ["12-Channel Recording", "Wi-Fi Sync", "Auto Interpretation", "Touch Interface"]
    },
];

export const WHY_CHOOSE = [
    { icon: "FaCheckCircle", title: "Genuine Products", desc: "Sourced directly from authorized manufacturers." },
    { icon: "FaUserMd",      title: "Expert Service Team", desc: "Certified biomedical engineers on call 24×7." },
    { icon: "FaShippingFast",title: "Fast Installation", desc: "Same-week deployment across Puducherry & Tamil Nadu." },
    { icon: "FaTags",        title: "Affordable Pricing", desc: "Best market rates with transparent quotations." },
    { icon: "FaHeadset",     title: "Customer Support", desc: "Dedicated account manager for every client." },
    { icon: "FaStar",        title: "Trusted by Healthcare Pros", desc: "5.0 Google rating from hospitals & clinics." },
];

export const INDUSTRIES = [
    { icon: "FaHospital",       name: "Hospitals" },
    { icon: "FaClinicMedical",  name: "Clinics" },
    { icon: "FaFlask",          name: "Laboratories" },
    { icon: "FaMicroscope",     name: "Diagnostic Centres" },
    { icon: "FaUniversity",     name: "Medical Colleges" },
    { icon: "FaHandHoldingMedical", name: "Healthcare Institutions" },
];

export const STATS = [
    { value: 500, suffix: "+", label: "Happy Clients" },
    { value: 2500, suffix: "+", label: "Products Delivered" },
    { value: 8500, suffix: "+", label: "Service Calls Completed" },
    { value: 12, suffix: "+", label: "Years of Experience" },
];

export const TESTIMONIALS = [
    {
        name: "PREM B.",
        text: "Bought portable xray medion brand... Quality was really super and service support really appreciated. Whenever we called them for any support mr. Santhosh responsed immediately and gave the instant service support."
    },
    {
        name: "AATHI RAM",
        text: "Reliable oxygen concentrator . Excellent customer support . Great product quality . Outstanding service experience. Timely delivery provided . Highly satisfied."
    },
    {
        name: "COOL RIDER25.",
        text: "We recently availed the services of Ezhil Biomedical Sales and Services, based in Karuvadikuppam, Puducherry, for servicing our dental autoclave. They were the only biomedical service team willing and capable of handling the autoclave that was originally purchased from a dental sales team in Chennai."
    },
    {
        name: "PRAKASH SUNDAR",
        text: "I recently purchased the fully automatic autoclave machine from ezhil biomedical..good quality, good response and timely delivered and given installation and demo..I really suggest them to good response for purchase and service related queries."
    },
    {
        name: "Nimmi Murugan NIMMI MURUGAN",
        text: "I recently purchased fromezhil biomedical, product quality and prices are affordable.Their services support is too good.I really suggest them to all to purchase from them..."
    },
];


export const BRAND_PARTNERS = [
    "Philips", "GE Healthcare", "Mindray", "Siemens", "Nihon Kohden",
    "Drager", "BPL Medical", "Schiller", "Skanray", "Olympus"
];

// Add this at the bottom of your existing content.js file

export const SEO_KEYWORDS = {
    hiddenParagraph: "Ezhil Biomedical Sales and Services is the leading provider of medical equipment in India, specializing in Philips Patient Monitors, GE Healthcare Ventilators, Siemens Diagnostic tools, and Mindray ICU equipment. We serve Puducherry, Tamil Nadu, Kerala, Karnataka, and Andhra Pradesh. Our services include medical gas pipeline installation, hospital furniture supply, surgical instrument wholesale, and biomedical engineering consultancy. We are experts in NABH calibration and NABL standards for hospital equipment maintenance.",
    globalLocations: "Serving Puducherry, Chennai, Bangalore, Hyderabad, Mumbai, Delhi, and global medical markets."
};

export const GALLERY = {
    equipment: [
        "https://5.imimg.com/data5/SELLER/Default/2026/3/592532902/HH/PG/FH/18170123/semi-automatic-cylindrical-autoclave-500x500.jpg",
        "https://biomedicalservices.jaivibe.com/images/slides/slide-3.jpg",
        "https://images.pexels.com/photos/19814026/pexels-photo-19814026.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://images.pexels.com/photos/8533045/pexels-photo-8533045.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://www.qglobalacademy.com/wp-content/uploads/2020/06/14971.jpg",
        "https://images.pexels.com/photos/10987574/pexels-photo-10987574.jpeg",
    ],
    installation: [
        "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=900&auto=format&fit=crop",
        "https://images.pexels.com/photos/8413159/pexels-photo-8413159.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://images.unsplash.com/photo-1551076805-e1869033e561?w=900&auto=format&fit=crop",
        "https://images.pexels.com/photos/8442105/pexels-photo-8442105.jpeg",
        "https://images.pexels.com/photos/9259976/pexels-photo-9259976.jpeg",
        "https://images.unsplash.com/photo-1666214280391-8ff5bd3c0bf0?w=900&auto=format&fit=crop",
    ],
    service: [
        "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1583912086094-e1ab1ed75bbc?w=900&auto=format&fit=crop",
    ],
};

export const FAQS = [
    { q: "What types of medical equipment do you supply?",
      a: "We supply a complete range of hospital, surgical, ICU, oxygen, laboratory and diagnostic equipment from leading global brands." },
    { q: "Do you provide installation and on-site training?",
      a: "Yes. Our certified biomedical engineers handle installation, commissioning and complete user training at your facility." },
    { q: "Do you offer Annual Maintenance Contracts (AMC)?",
      a: "Yes. We offer flexible Comprehensive and Non-Comprehensive AMC plans for hospitals, clinics, labs and diagnostic centres." },
    { q: "Which areas do you serve?",
      a: "We primarily serve Puducherry, Tamil Nadu and surrounding regions, with project-based service across South India." },
    { q: "Are your equipment calibrations NABH/NABL compliant?",
      a: "Absolutely. All calibrations are performed using traceable standards aligned with NABH and NABL guidelines." },
    { q: "How quickly can you respond to a service breakdown?",
      a: "Our standard response time is within 24 hours, with priority same-day response for critical care equipment under AMC." },
];
